import { render, staticRenderFns } from "./ProviderSelect.vue?vue&type=template&id=54cf58e0&"
import script from "./ProviderSelect.vue?vue&type=script&lang=js&"
export * from "./ProviderSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSelect.vue?vue&type=style&index=0&id=54cf58e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports